import React from "react";
import locales from "../../locales";
import {Button, Divider, Icon, Modal, Select} from "antd";
import {Contact} from "../../api/dtos/dtos";
import Label from "../Label";
import {OptionProps} from "antd/lib/select";
import {isNullOrBlank, normalizeForSearch} from "../../utils/string-utils";
import ClientContactForm from "../../client-details/ClientContactForm";

interface Props {
  disabled: boolean;
  contacts: Contact[];
  selectedContactIds: number[];
  onSaveContact: (contact: Contact) => void;
  onChange: (contactIds: number[]) => void;
}

interface State {
  editedContact?: Contact;
}

class ClientContactsSelector extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {}
  }

  public render(): React.ReactNode {
    const {contacts, selectedContactIds, disabled, onChange} = this.props;
    const {editedContact} = this.state;

    return (
      <>
        <Select
          mode="multiple"
          className="mild-disabled"
          style={{width: '100%'}}
          showSearch={true}
          allowClear={true}
          placeholder={locales.choose}
          notFoundContent={locales.contact_selector_no_email}
          // disabled={disabled}
          value={selectedContactIds}
          onChange={onChange}
          filterOption={this.filterOptions}
          dropdownRender={this.renderDropdownOptions}
          disabled={disabled}
        >
          {contacts.length > 0 && contacts.map(this.renderContactOptions)}
        </Select>

        <Modal
          title={locales.edit_contact}
          visible={editedContact !== undefined}
          footer={null}
          destroyOnClose={true}
          onCancel={this.onContactEditCancel}
        >
          {editedContact && <ClientContactForm
              contact={editedContact}
              emailRequired={true}
              onFormSubmit={this.onContactEditSave}
              onFormCancel={this.onContactEditCancel}
          />}
        </Modal>
      </>
    )
  }

  private renderContactOptions = (c: Contact): React.ReactNode => {
    const onClientEdit = (_: React.MouseEvent<HTMLDivElement>) => this.onClientEdit(c);

    return (
      <Select.Option
        disabled={isNullOrBlank(c.email)}
        key={String(c.id)}
        value={c.id!}
        title={c.name}
      >
        {c.name}
        {!c.email && <Button style={{marginLeft: 8, height: 24, width: 24}} icon='edit' onClick={onClientEdit}/>
        }
        {c.email && <Label value={c.email}/>}
        {c.deleted && <Label value={`(${locales.deleted})`}/>}
      </Select.Option>
    );
  };

  private renderDropdownOptions = (optionItems: React.ReactNode) => {
    return (
      <div>
        {optionItems}
        <Divider style={{margin: '4px 0'}}/>
        <div
          style={{padding: '4px 8px', cursor: 'pointer'}}
          onMouseDown={this.preventDefault}
          onClick={this.onNewContact}
        >
          <Icon type="plus"/>{locales.add}
        </div>
      </div>
    )
  };

  private preventDefault(e: React.MouseEvent<HTMLDivElement>) {
    e.preventDefault();
  }

  private onClientEdit(c: Contact) {
    this.setState({editedContact: c});
  }

  private onNewContact = () => {
    this.setState({
      editedContact: {
        id: null,
        name: '',
        title: null,
        tel: null,
        email: null,
        idNumber: null,
        mothersName: null,
        deleted: false,
      },
    });
  };

  private filterOptions = (input: string, option: React.ReactElement<OptionProps>) => {
    const inp = normalizeForSearch(input);
    const opt = normalizeForSearch(option.props.title || "");
    return opt.indexOf(inp) >= 0;
  };

  private onContactEditCancel = () => {
    this.setState({editedContact: undefined});
  };

  private onContactEditSave = (contact: Contact) => {
    this.props.onSaveContact(contact);
    this.setState({editedContact: undefined});
  };
}

export default ClientContactsSelector;


// WEBPACK FOOTER //
// ./src/common/contact/ClientContactsSelector.tsx